import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import * as types from './types';
import fetchLookbook from '../../../services/lookbook';
export default {
  fetchLookbook(_ref, _ref2) {
    var _this = this;

    return _asyncToGenerator(function* () {
      let {
        commit
      } = _ref;
      let {
        query
      } = _ref2;
      let data = yield fetchLookbook(_this, query);
      commit(types.SET_LOOKBOOK, data);
      data = null;
    })();
  },

  appendAmbiences(_ref3, _ref4) {
    var _this2 = this;

    return _asyncToGenerator(function* () {
      let {
        commit
      } = _ref3;
      let {
        query
      } = _ref4;
      commit(types.SET_LOADING_AMBIENCES, true);
      let data = yield fetchLookbook(_this2, query);
      commit(types.APPEND_AMBIENCES, data);
      commit(types.SET_LOADING_AMBIENCES, false);
      data = null;
    })();
  },

  prependAmbiences(_ref5, _ref6) {
    var _this3 = this;

    return _asyncToGenerator(function* () {
      let {
        commit
      } = _ref5;
      let {
        query
      } = _ref6;
      commit(types.SET_LOADING_AMBIENCES, true);
      let data = yield fetchLookbook(_this3, query);
      commit(types.PREPEND_AMBIENCES, data);
      commit(types.SET_LOADING_AMBIENCES, false);
      data = null;
    })();
  }

};